import { createRootRoute, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Toaster } from '../components/Toaster.js';

export const Route = createRootRoute({
  component: () => (
    <div className="min-h-screen bg-zinc-950 text-zinc-100">
      <Outlet />
      <Toaster />
    </div>
  ),
  notFoundComponent: NotFoundPage,
});

function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950 px-6 py-8 text-zinc-100">
      <div className="max-w-md rounded-xl border border-zinc-800 bg-zinc-900/40 p-6 text-center">
        <img src="/icon.png" alt="" className="mx-auto mb-4 h-12 w-12 opacity-60" />
        <h1 className="mb-2 text-2xl font-semibold">{t('notFound.title')}</h1>
        <p className="mb-4 text-sm text-zinc-400">{t('notFound.body')}</p>
        <a
          href="/"
          className="inline-block rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-indigo-500"
        >
          {t('notFound.backHome')}
        </a>
      </div>
    </div>
  );
}
